import {inject, Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {ReturnsStore} from "./core/store/returns.state";
import {EmailTemplateEnum} from "./core/enums/email-template.enum";
import {
	AddRequestBodyModel,
	AddRequestResponseModel,
	ClientReturnsDataModel, OrderItemsDataModel,
	ReturnsDataModel, YouReturnsResponseModel
} from "./core/models/client-returns-data.model";
import {OrderStatusEnum} from "./core/enums/order-status.enum";

@Injectable({
	providedIn: 'root'
})
export class ApiService {
	headers = new HttpHeaders();
	emailTemplateEnum = EmailTemplateEnum;
	private _store = inject(ReturnsStore);

	constructor(private httpClient: HttpClient) {
		this.headers = this.headers.append('Content-Type', 'application/json');
		this.headers = this.headers.append('Authorization', 'Basic ' + btoa(`${environment.user}:${environment.pass}`));
	}

	read_data(email: string, orderNumber: string): Observable<ClientReturnsDataModel> {
		return this.httpClient.get<any>(`${environment.api_url}/order_view`, {
			headers: this.headers, params: {
				email,
				orderNumber
			}
		}).pipe(map((res: ClientReturnsDataModel) => {
			return {
				...res,
				mappedOrderStatus: this._parseOrderStatus(res.status),
				order_items: res.order_items.map((item: OrderItemsDataModel) => {
					return {
						...item,
						quantityList: Array.from({length: item.quantity}, (_, i) => i + 1),
						pricePerBundle: item.selling_price * item.quantity
					}
				})
			}
		}));
	}

	your_return(email: any, order_num: any): Observable<ClientReturnsDataModel> {
		let params = new HttpParams();
		params = params.append('email', email);
		params = params.append('order', order_num);
		return this.httpClient.get<ClientReturnsDataModel>(`${environment.api_url}/order_view`, {
			headers: this.headers,
			params: params
		});
	}

	get_your_return_document(return_no: number): Observable<YouReturnsResponseModel> {
		let params = new HttpParams();
		params = params.append('return_no', return_no);

		return this.httpClient.get<YouReturnsResponseModel>(`${environment.api_url}/your_return_document`, {
			headers: this.headers,
			params: params
		});
	}

	add_request(body: AddRequestBodyModel): Observable<AddRequestResponseModel> {
		return this.httpClient.post<AddRequestResponseModel>(`${environment.api_url}/add_request`, body, {headers: this.headers});
	}

	sendEmail(options: { file: any, name: string, orderNumber: string, emailTo: string }): Observable<any> {
		const state = this._store.getCurrentState();

		const handleBrandTemplate = (brand: string) => {
			switch (brand) {
				case 'BAGATT':
					return this.emailTemplateEnum.BAGATT;
				case 'SALAMANDER':
					return this.emailTemplateEnum.SALAMANDER;
				default:
					return this.emailTemplateEnum.BUGATTI;
			}
		}

		const formData = new FormData();
		formData.append('to', options.emailTo);
		formData.append('notificationTemplate', handleBrandTemplate(state.source));
		formData.append('languageCode', this.handleLanguage(sessionStorage.getItem('lang')!));
		formData.append('template[customer_name]', options.name);
		formData.append('template[order_number]', options.orderNumber);
		formData.append('attachments', options.file, 'Return Documents.pdf');

		return this.httpClient.post<any>(`${environment.api_url}/send-return-request-notification`, formData);
	}

	handleLanguage = (lang: string) => {
		switch (lang) {
			case 'de':
				return 'DE';
			default:
				return 'EN';
		}
	}

	get_returns(orderNumber: string): Observable<ReturnsDataModel[]> {
		return this.httpClient.get<ReturnsDataModel[]>(`${environment.api_url}/get_returns`, {
			headers: this.headers, params: {
				orderNumber
			}
		});
	}

	generateDownloadFileName(orderNumber: string): string {
		const today = new Date();

		const day = String(today.getDate()).padStart(2, '0');
		const month = String(today.getMonth() + 1).padStart(2, '0');
		const year = today.getFullYear();

		return `${day}_${month}_${year}_${orderNumber}.pdf`;
	}

	private _parseOrderStatus(status: string): string {
		if (status === OrderStatusEnum.NOT_FULFILLED) {
			return 'Open';
		}
		return 'Closed';
	}

}
